import React, { useState } from "react";
import { images } from "../../assets/images";
import { useNavigate } from "react-router-dom";
import { sendOTP } from "../../services/authService";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await sendOTP(email);
      localStorage.setItem('email', email);
      navigate("/forgot-otp");
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to send OTP. Please try again.");
    }
  };

  return (
    <section className="login-section-bg">
      <div className="container-main">
        <div className="d-flex justify-content-center mb-2">
          <div className="auth-logo">
            <img
              src={images.logoHorizontal}
              alt="app-logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = images.appLogo;
              }}
            />
          </div>
        </div>

        <div className="card auth-card mt-2">
          <div className="d-flex justify-content-between mb-2">
            <i
              className="fa-solid fa-arrow-left fa-lg text-primary cursor-pointer"
              onClick={() => navigate("/")}
            ></i>

            <div>
              <h4 className="fw-semibold text-center fs-20">Trouble logging in?</h4>
              <p className="mb-3 text-muted text-center fs-15">
                Enter your email and we'll send you a reset link.
              </p>
            </div>

            <div></div>
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="">
              <label className="form-label">
                Email
                <span className="text-danger"> *</span>
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-control input-tags"
                placeholder="Enter email"
              />
            </div>

            {error && <p className="text-danger fs-13 mt-2 mb-0">{error}</p>}

            <div className="mt-4 text-center">
              <button type="submit" className="btn btn-primary w-100 mt-2">
                Create Password
              </button>
            </div>
          </form>
          <p className="text-center mb-0 text-muted fs-13 mt-3">
            I remember my password?{" "}
            <a href="/" className="link text-primary text-decoration-underline">
              Sign In here
            </a>
          </p>
        </div>
        <p className="position-relative text-center fs-13 mb-0 mt-3 text-muted">
          © {new Date().getFullYear()} AI Project. All Rights Reserved.
        </p>
      </div>
    </section>
  );
};

export default ForgotPassword;
